import { useMemo } from 'react'
import { AutoComplete, Input } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useReasonHistory } from './useReasonHistory'
import { getReasonStorage } from './provider'

type Props = {
  scope: string
  value: string
  onChange: (val: string) => void
  placeholder?: string
  multiline?: boolean
  rows?: number
  size?: 'small' | 'middle' | 'large'
  autoFocus?: boolean
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
  style?: React.CSSProperties
  className?: string
}

export function ReasonAutoComplete({
  scope,
  value,
  onChange,
  placeholder,
  multiline,
  rows = 3,
  size,
  autoFocus,
  disabled,
  onClick,
  style,
  className,
}: Props) {
  const { entries, remove } = useReasonHistory(scope)

  const options = useMemo(() => {
    const q = value.trim().toLowerCase()
    return entries
      .filter((e) => !q || e.text.toLowerCase().includes(q))
      .map((e) => ({
        value: e.text,
        label: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
            }}
          >
            <span
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {e.text}
            </span>
            <CloseOutlined
              style={{ fontSize: 10, opacity: 0.5 }}
              onClick={(ev) => {
                ev.stopPropagation()
                ev.preventDefault()
                remove(e.text)
              }}
            />
          </div>
        ),
      }))
  }, [entries, value, remove])

  return (
    <AutoComplete
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      style={{ width: '100%', ...style }}
      className={className}
      onClick={onClick}
      filterOption={false}
      autoFocus={autoFocus}
    >
      {multiline ? (
        <Input.TextArea rows={rows} placeholder={placeholder} />
      ) : (
        <Input size={size} placeholder={placeholder} />
      )}
    </AutoComplete>
  )
}

export function commitReason(scope: string, text: string) {
  return getReasonStorage().commit(scope, text)
}
